import { render, staticRenderFns } from "./WelcomeSignupTMF.vue?vue&type=template&id=5d6dacf6&scoped=true&"
import script from "./WelcomeSignupTMF.vue?vue&type=script&lang=ts&"
export * from "./WelcomeSignupTMF.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeSignupTMF.vue?vue&type=style&index=0&id=5d6dacf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6dacf6",
  null
  
)

export default component.exports